import React, { type ReactNode } from 'react';
import EmptyState from '@atlaskit/empty-state';
import { ff } from '@atlassian/jira-feature-flagging';
import HelpPanelLink from '@atlassian/jira-help-panel-button';
import { useIntl } from '@atlassian/jira-intl';
import { IPH_IDS } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import DocLink from '@atlassian/jira-portfolio-3-portfolio/src/common/view/doc-link';
import NoDependencyImage from './images/NoDependency.svg';
import TooManyFiltersImage from './images/TooManyFilters.svg';
import WarningImage from './images/WarningState.svg';
import messages from './messages';
import { ScreenType, type Props } from './types';

export default function StateScreen({ type }: Props) {
	const { formatMessage } = useIntl();
	let imageUrl;
	let title = '';
	let text;
	let primaryAction;
	switch (type) {
		case ScreenType.WARNING:
			imageUrl = WarningImage;
			title = formatMessage(messages.warningTitle);
			text = formatMessage(messages.warningText);
			break;
		case ScreenType.EMPTY_NO_DEPENDENCY:
			imageUrl = NoDependencyImage;
			title = formatMessage(messages.noDependencyTitle);
			text = formatMessage(messages.noDependencyText, {
				// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
				strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
			});
			primaryAction = ff('in-product-help-for-plans_qwds9') ? (
				<HelpPanelLink
					articleId={IPH_IDS.DEPENDENCIES_REPORT}
					fallbackComponent={
						<DocLink href={DocLink.URLs.dependencyReport}>
							{formatMessage(messages.iphLink)}
						</DocLink>
					}
					appearance="link"
					spacing="none"
				>
					{formatMessage(messages.iphLink)}
				</HelpPanelLink>
			) : (
				<DocLink href={DocLink.URLs.dependencyReport}>
					{formatMessage(messages.learnMoreLink)}
				</DocLink>
			);
			break;
		case ScreenType.EMPTY_TOO_MANY_FILTERS:
			imageUrl = TooManyFiltersImage;
			title = formatMessage(messages.tooManyFiltersTitle);
			text = formatMessage(messages.tooManyFiltersText);
			break;
		default:
			break;
	}
	return (
		<EmptyState
			imageUrl={imageUrl}
			maxImageWidth={230}
			header={title}
			description={text}
			primaryAction={primaryAction}
		/>
	);
}
